export function Button({ onClick, disabled, children, className }: { onClick: any, children: any, disabled?: any, className?: string }) {
    return (
        <button onClick={onClick}
            className={`py-2 px-6 rounded-md shadow-md transition-all duration-300 ease-in-out 
                text-sm font-medium
        ${disabled
                    ? 'bg-gray-200 cursor-not-allowed text-gray-600'
                    : 'bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:from-blue-700 hover:to-blue-600 active:shadow-inner'
                }
        ${className || ''}
        `}
            disabled={disabled}>
            {children}
        </button>
    )
}

